import React from 'react'
import styles from 'styles/components/AddPaymentCard.module.sass'
import { Plus } from 'lucide-react';

interface AddPaymentCardProps {
    onAddPaymentMethod: () => void;
}

/**
 * AddPaymentCard component - A card that allows users to add a new payment method.
 * @component
 * 
 * @param {AddPaymentCardProps} props The component props.
 * @param {() => void} props.onAddPaymentMethod Callback function to call when the user wants to add a payment method.
 * 
 * @example
 * <AddPaymentCard onAddPaymentMethod={() => console.log("Add Payment Method clicked")} />
 * 
 * @returns {JSX.Element} AddPaymentCard component
 */
const AddPaymentCard: React.FC<AddPaymentCardProps> = ({ onAddPaymentMethod }) => {
    return (
        <div className={styles['add-card']} onClick={onAddPaymentMethod} role='button' tabIndex={0} aria-label='Add Payment Method' onKeyPress={onAddPaymentMethod}>
            <div className={styles['icon-container']}>
                <div className={styles['icon-background']} />
                <div className={styles['icon-background-inner']} />
                <div className={styles['icon-wrapper']}>
                    <Plus className={styles['plus-icon']} />
                </div>
            </div>

            <div className={styles['text-content']}>
                <p className={styles['title']}>
                    Add Payment Method
                </p>
                <p className={styles['subtitle']}>
                    Add a new credit or debit card to manage your subscription payments.
                </p>
            </div>

            <div className={styles['animated-border']} />
        </div>
    )
}

export default AddPaymentCard;